import { render, staticRenderFns } from "./InventoryChangeForm.vue?vue&type=template&id=15b3ec1e&"
import script from "./InventoryChangeForm.vue?vue&type=script&lang=js&"
export * from "./InventoryChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports